import { Button, CircularProgress, IconButton } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import RemoveModeratorIcon from "@mui/icons-material/RemoveModerator";
import * as React from "react";
import { putTeamOfficialStatus } from "../hooks/useTeam";
import { ITeam } from "utils/api.interfaces";

interface OfficialStatusButtonProps {
  team?: ITeam;
  refetch: () => Promise<any>;
}

/**
 * Toggles a team's `isOfficial` status via the MM override endpoint.
 * The API enforces who may change it (403 for non club-admin/MM) and rejects
 * promoting Default-Organisation teams, so failures are surfaced to the user.
 */
const OfficialStatusButton: React.FC<OfficialStatusButtonProps> = ({
  team,
  refetch,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const handleToggle = () => {
    if (!team) return;
    setIsLoading(true);
    putTeamOfficialStatus(team.id, !team.isOfficial)
      .then(() => refetch())
      .catch((e: any) => {
        alert(
          e?.response?.data?.message ||
            "Failed to update official status. Only club admins / MM staff can change this, and Default-Organisation teams cannot be made official."
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Button
      color={team?.isOfficial ? "error" : "success"}
      variant="outlined"
      size="small"
      onClick={handleToggle}
      disabled={isLoading || !team}
      startIcon={team?.isOfficial ? <RemoveModeratorIcon /> : <VerifiedIcon />}
      sx={{ fontSize: "12px", padding: "5px 10px" }}
      endIcon={
        isLoading && (
          <IconButton aria-label="" edge="end">
            <CircularProgress
              size={15}
              sx={{ color: "#68F3CB" }}
              color="success"
            />
          </IconButton>
        )
      }
    >
      {team?.isOfficial ? "Remove official status" : "Mark as official"}
    </Button>
  );
};

export default OfficialStatusButton;
